import { createContext, useCallback, useContext, useState } from 'react'

export const NotificationContext = createContext({
  notifications: [],
  showNotification: () => {},
  removeNotification: () => {}
})

export const useNotification = () => {
  const context = useContext(NotificationContext)
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider')
  }
  return context
}

let notificationId = 0

export function NotificationProvider({ children }) {
  const [notifications, setNotifications] = useState([])

  const showNotification = useCallback((message, type = 'info', duration = 5000) => {
    const id = ++notificationId
    const notification = { id, message, type, timestamp: Date.now() }

    setNotifications(prev => [...prev, notification])

    // Auto remove after duration
    setTimeout(() => {
      setNotifications(prev => prev.filter(n => n.id !== id))
    }, duration)

    return id
  }, [])

  const removeNotification = useCallback((id) => {
    setNotifications(prev => prev.filter(n => n.id !== id))
  }, [])

  return (
    <NotificationContext.Provider value={{ 
      notifications, 
      showNotification, 
      removeNotification 
    }}>
      {children}
      <NotificationContainer />
    </NotificationContext.Provider>
  )
}

function NotificationContainer() {
  const { notifications, removeNotification } = useContext(NotificationContext)

  return (
    <div className="notification-container">
      {notifications.map(notification => (
        <div
          key={notification.id}
          className={`notification notification-${notification.type}`}
          onClick={() => removeNotification(notification.id)}
          style={{
            position: 'fixed',
            top: `${80 + notifications.findIndex(n => n.id === notification.id) * 70}px`,
            right: '20px',
            zIndex: 1000,
            padding: '12px 16px',
            borderRadius: '4px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            cursor: 'pointer',
            minWidth: '300px',
            maxWidth: '400px',
            color: 'white',
            fontWeight: '500',
            animation: 'slideIn 0.3s ease-out',
            backgroundColor: getNotificationColor(notification.type)
          }}
        >
          {notification.message}
        </div>
      ))}
    </div>
  )
}

function getNotificationColor(type) {
  switch (type) {
    case 'success': return '#4caf50'
    case 'error': return '#f44336'
    case 'warning': return '#ff9800'
    case 'info': return '#2196f3'
    default: return '#757575'
  }
}


